import createInlineElement from './createInlineElement';

export default function createTextInlineElement(inlineEdit, inlineEditAnchor = false, linkConfig) {
  const inlineEditValue = inlineEdit.innerHTML;
  if (inlineEditAnchor) {
    inlineEdit.innerHTML = '';
    inlineEditAnchor.classList.add('format-done');
    inlineEditAnchor.classList.add('inline--edit__anchor');
    inlineEdit.appendChild(createInlineElement(inlineEditValue, linkConfig));
  } else {
    inlineEdit.classList.add('format-done');
    inlineEdit.innerHTML = '';
    inlineEdit.appendChild(createInlineElement(inlineEditValue));
  }
}



// WEBPACK FOOTER //
// ./js/components/tables/inline-edit/createElements/createTextInlineElement.js